namespace Areas.Analysis.ReportsFinance {
    "use strict";

    export function ProcessExtract() {
        const form = $("#ExtractForm").dxForm("instance");
        const formData: any = form.option("formData");


        let lastDateOfWeek = formData.lastDateOfWeek;
        if (lastDateOfWeek != null) {
            lastDateOfWeek = moment(formData.lastDateOfWeek).format('YYYY-MM-DD');
        }

        const url = `/Analysis/ReportsFinance/ProcessExtract/${lastDateOfWeek}`;
        sendRequest(url, null, 'Put');
    }


    export function ProcessReconcileCompleted() {
        const form = $("#ReconcileForm").dxForm("instance");
        const formData: any = form.option("formData");

        let lastDateOfUploadMonth = formData.lastDateOfUploadMonth;
        if (lastDateOfUploadMonth != null) {
            lastDateOfUploadMonth = moment(formData.lastDateOfUploadMonth).format('YYYY-MM-DD');
        }

        let weekEndingDate = formData.weekEndingDate;
        if (weekEndingDate != null) {
            weekEndingDate = moment(formData.weekEndingDate).format('YYYY-MM-DD');
        }

        const url = `/Analysis/ReportsFinance/ProcessReconcileCompleted/${lastDateOfUploadMonth}/${weekEndingDate}`;
        sendRequest(url, null, 'Put');

    }

}